function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { Column } from 'seagull';
import { outputToCost } from "../../../../../components/ServiceCreation/ServiceBuilder/ServiceBuilder.utils";
import ServicePriceEditorPopoverBundleContent from "../../../../../components/ServicePriceEditorPopover/ServicePriceEditorPopoverBundleContent/ServicePriceEditorPopoverBundleContent";
import ServicePriceEditorPopoverPricingContent from "../../../../../components/ServicePriceEditorPopover/ServicePriceEditorPopoverPricingContent/ServicePriceEditorPopoverPricingContent";
import { serviceModel } from "../../../../../models";
import { inputBillingDataToModel } from "../../../../../models/service-billing/setters";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function getEffectiveTrigger(data) {
  const {
    pricing,
    trigger
  } = data;
  const isVariablePricing = pricing === 'hour' || pricing === 'unit' || pricing === 'range';
  if (isVariablePricing && trigger === 'ongoing') {
    return 'manualVariable';
  }
  return trigger;
}
export const ServiceRateModalContent = _ref => {
  let {
    service,
    draft,
    setDraft
  } = _ref;
  const {
    watch
  } = useFormContext();
  useEffect(() => {
    const subscription = watch(formValues => {
      const data = formValues;
      const cost = outputToCost({
        output: data,
        originalService: service
      });
      const effectiveTrigger = getEffectiveTrigger(data);
      const billing = inputBillingDataToModel({
        billingForm: _objectSpread(_objectSpread({}, data), {}, {
          trigger: effectiveTrigger
        }),
        originalService: service
      });
      setDraft(draft.setService(service.id, s => {
        let updated = serviceModel.setCost(s, cost);
        updated = serviceModel.setBillingTrigger(updated, billing);
        return updated;
      }));
    });
    return () => subscription.unsubscribe();
  }, [watch, service, draft, setDraft]);
  return /*#__PURE__*/_jsxs(Column, {
    children: [/*#__PURE__*/_jsx(ServicePriceEditorPopoverPricingContent, {
      serviceOrigin: "draft"
    }), /*#__PURE__*/_jsx(ServicePriceEditorPopoverBundleContent, {})]
  });
};